<template>
  <!-- Modal -->
  <div class="modal fade" id="SingleConsignmentStockReturnModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">委託在庫の戻り入力</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>JANコード</th>
                <th>型番</th>
                <th>倉庫名</th>
                <th>区分</th>
                <th>在庫数</th>
                <th>在庫戻り</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(product, i) in warehouseProducts">
              <tr :key="i">
                <td>{{product.isShowJanCode ? product.jan_code : ''}}</td>
                <td>{{product.isShowJanCode ? product.type_number : ''}}</td>
                <td>{{product.warehouse_name}}</td>
                <td>{{Number(product.defective) === 1 ? '不良品' : '良品'}}</td>
                <td class="right">{{Number(product.stock_quantity).toLocaleString()}}</td>
                <td>
                  <input v-model="product.shippingAmount" class="form-control form-control-sm" type="text" placeholder="0" min-value="0">
                </td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div>
            <button type="button" class="btn btn-danger" @click="addShipping(true)" :disabled="IS_TODO">契約終了</button>
          </div>
          <div>
            <button ref="closeModal" type="button" class="btn btn-secondary mr-3" data-dismiss="modal">閉じる</button>
            <button type="button" class="btn btn-primary" @click="addShipping(false)" :disabled="IS_TODO">更新</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'SingleConsignmentStockReturnModal',
  components: {
    VueElementLoading
  },
  props: {
    outsourcingStatus: null
  },
  data () {
    return {
      IS_TODO: true,
      shippingAt: '',
      displayWarning: false,
      isSearching: false,
      warehouseProducts: []
    }
  },
  created () {
  },
  mounted () {
    window.$('#SingleConsignmentStockReturnModal').on('shown.bs.modal', () => {
      this.listWarehouseProducts()
    })
    window.$('#SingleConsignmentStockReturnModal').on('hide.bs.modal', () => {
      this.warehouseProducts = []
    })
  },
  methods: {
    showWarning () {
      let date = new Date().getDate()

      this.displayWarning = (date >= 25)
    },
    async listWarehouseProducts (closeModal) {
      try {
        let response = await this.$http.post(this.$api_url.orders_consignment_warehouse_products, { younosuke_customer_id: this.$parent.currentInfo.client_id })
        let $data = this.$invoiceTools.prepareResult(response.data, 'item_list', 'SingleConsignmentStockReturnModal:listWarehouseProducts')
        if ($data.success === true) {
          this.warehouseProducts = $data.data
        } else {
          this.warehouseProducts = []
          this.$toastr.error($data.data, 'エラー')
        }
        this.initializeShippingAmounts()
        this.isSearching = false
        if (closeModal) this.$refs.closeModal.click()
      } catch (error) {
        console.log('SingleConsignmentStockReturnModal:listWarehouseProducts:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isSearching = false

        this.initializeShippingAmounts()
      }
    },

    initializeShippingAmounts () {
      let currentProductId = ''
      let currentJanCode = ''
      let currentTypeNumber = ''
      let currentAmount = 0
      let currentClientOrderNumber = ''
      let currentUnitPrice = 0
      this.warehouseProducts.forEach(function (product, index) {
        if (product.warehouse_id === product.mainwarehouse_id && !product.defective) {
          product.shippingAmount = product.amount
        } else {
          product.shippingAmount = 0
        }
        if (currentProductId === product.product_id && currentJanCode === product.jan_code && currentTypeNumber === product.type_number && currentAmount === product.amount && currentClientOrderNumber === product.client_order_number && currentUnitPrice === product.unit_price) {
          product.isShowJanCode = false
        } else {
          currentProductId = product.product_id
          currentJanCode = product.jan_code
          currentTypeNumber = product.type_number
          currentAmount = product.amount
          currentClientOrderNumber = product.client_order_number
          currentUnitPrice = product.unit_price
          product.isShowJanCode = true
        }
      })
    },

    async addShipping (returnAll) {
      // if (this.shippingAt === '') {
      //   this.$toastr.warning('処理日をご入力ください')
      //   return
      // }

      try {
        let amountError = false
        this.isSearching = true
        let productList = []
        let self = this
        this.warehouseProducts.forEach(function (product) {
          if (Number(product.shippingAmount) > 0 || returnAll) {
            if (Number(product.shippingAmount) > Number(product.stock_amount) && !returnAll) { // 在庫戻り > 在庫数
              amountError = true
              return // CONTINUE
            }
            productList.push({
              detail_id: product.detail_id,
              warehouse_id: product.warehouse_id,
              defective: product.defective,
              product_id: product.product_id,
              jan_code: product.jan_code,
              type_number: product.type_number,
              unit_price: product.unit_price,
              client_order_number: product.client_order_number,
              stock_amount: Number(product.stock_quantity),
              amount: !returnAll ? Number(product.shippingAmount) : Number(product.stock_quantity),
              younosuke_customer_id: self.$parent.currentInfo.client_id
            })
          }
        })
        if (amountError) {
          this.isSearching = false
          this.$toastr.warning('在庫数以下の在庫戻りを入力してください。')
          return
        }

        if (productList.length === 0) {
          this.isSearching = false
          this.$toastr.warning('在庫戻り数を入力してください。')
          return
        }

        let params = {
          return_all: returnAll,
          bill_to_id: this.$parent.currentInfo.client_id,
          // shipping_at: this.shippingAt.replace(/-/gi, ''),
          product_list: productList
        }
        let response = await this.$http.post(this.$api_url.orders_update_consignment_stocks, params)
        console.log('SingleConsignmentStockReturnModal:response', response)
        if (response.data.status === true) {
          this.$toastr.success('委託在庫の戻りを入力しました。', 'Success')
          // this.$parent.ordersInfo.sales_status = 1 // 0:未登録, 1:未請求, 2:請求済み // 在庫がなくなるまで再登録を許す
          this.listWarehouseProducts(true) // CLOSE MODAL
        } else {
          this.$toastr.error(response.data.message, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        console.log('SingleConsignmentStockReturnModal:updateOrders:catch(error): ', error)
        this.$toastr.error('委託在庫の戻りがエラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isSearching = false
      }
    }
  }
}
</script>
